/* QubikoTech | Pantalla de agradecimiento tras éxito REAL en Klaviyo.
 * La suscripción es gestionada íntegramente por Klaviyo; nunca se intercepta Submit.
 */
(() => {
  const successHash='#gracias';
  const activeClass='qt-thanks-active';
  const formSelector='.qt-landing .klaviyo-form-TNPpqt';
  const successText=/gracias por unirte|ya tienes tu primer recurso gratuito|primeros en enterarte sobre el nuevo producto|te enviaremos la gu[ií]a cuando est[eé] lista/i;
  function render() {
    const isThanks=location.hash.toLowerCase()===successHash;
    document.body.classList.toggle(activeClass,isThanks);
    const el=document.querySelector('.qt-landing .qt-thanks');
    if(!el)return;
    el.hidden=!isThanks;
    if(isThanks){document.title='¡Gracias por unirte! · QubikoTech';window.scrollTo({top:0,behavior:'instant'});}
  }
  function observe(root){
    if(root.dataset.qtThanksObserver)return;
    root.dataset.qtThanksObserver='1';
    let navigating=false;
    function check(){
      if(navigating||location.hash.toLowerCase()===successHash)return;
      const hasEmail=root.querySelector('input[type="email"]');
      const hasSuccess=successText.test(root.textContent||'');
      if(!hasEmail&&hasSuccess){
        navigating=true;
        location.hash='gracias';
        render();
      }
    }
    const observer=new MutationObserver(check);
    observer.observe(root,{childList:true,subtree:true,characterData:true});
    check();
    document.addEventListener('shopify:section:unload',event=>{if(event.target.contains(root))observer.disconnect()},{once:true});
  }
  function init(){
    render();
    document.querySelectorAll(formSelector).forEach(observe);
    const scan=new MutationObserver(()=>document.querySelectorAll(formSelector).forEach(observe));
    const landing=document.querySelector('.qt-landing');
    if(landing)scan.observe(landing,{subtree:true,childList:true});
  }
  window.addEventListener('hashchange',render);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
})();
